import { createCombined } from '@exodus/combined-assets-meta';
const ethereumtestnet = createCombined({
    name: '_ethereumtestnet',
    displayName: 'Ethereum Testnet',
    ticker: `_ethereumtestnet_ETH`,
    displayTicker: 'ETH',
    combinedAssetNames: ['ethereum', 'ethereumholesky', 'ethereumarbonesepolia'],
    units: { base: 0, _ethereumtestnet_ETH: 18 },
    assetType: 'MULTI_NETWORK_ASSET',
});
// HACK: The first `combinedAssetNames` needs to exist in `@exodus/combined-assets-meta`.
ethereumtestnet.combinedAssetNames = [
    'ethereumholesky',
    'ethereumarbonesepolia',
];
export default [
    //
    ethereumtestnet,
];
